import { RadioButton } from "~/components/RadioButton";
import { type KioskDisplayVariantChoice } from "~/stores/kiosk-session/hooks/use-kiosk-products/types";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { AllergensLabeled } from "~/components/allergens";

import { QuantityInputControl } from "../../Inputs/quantity-input-control/quantity-input-control";

type ChoiceProps = {
  choice: KioskDisplayVariantChoice;
  variantMaximum: number | null;
  checked: boolean;
  onRadioClick: () => void;
  quantity: number;
  onQuantityIncrease: () => void;
  onQuantityDecrease: () => void;
  displayPrice: string | undefined;
};

export const Choice = ({
  choice: { id, name, maximum: choiceMaximum, allergens: choiceAllergens },
  variantMaximum,
  checked = true,
  onRadioClick,
  quantity,
  onQuantityIncrease,
  onQuantityDecrease,
  displayPrice
}: ChoiceProps) => {
  const { language } = useCurrentTillLocalisation();

  const isQuantityEnabled =
    checked &&
    (choiceMaximum === null || choiceMaximum > 1) &&
    (variantMaximum === null || variantMaximum > 1);

  return (
    <div id={id} className="flex flex-col gap-2">
      <div className="flex h-12 w-full items-center justify-between gap-4">
        <RadioButton
          label={name}
          checked={checked}
          onClick={onRadioClick}
          variant="kiosk"
        />

        {displayPrice ? (
          <span className="shrink-0 text-3xl text-kiosk-text-secondary">{`+ ${displayPrice}`}</span>
        ) : null}

        {isQuantityEnabled ? (
          <QuantityInputControl
            quantity={quantity}
            onIncrementClick={onQuantityIncrease}
            onDecrementClick={onQuantityDecrease}
            variant="secondary"
            size="sm"
          />
        ) : null}
      </div>

      <AllergensLabeled
        allergens={choiceAllergens}
        languageCode={language}
        className="ml-8"
      />
    </div>
  );
};
